module.exports = __webpack_public_path__ + "img/titleBg.266fdc74.png";